export default __webpack_public_path__ + "static/media/IMG_2946.495dc0df.JPG";